import React from 'react';
import { connect } from 'react-redux';
import { toggleDialog } from '../../../store/control/duck';
import { injectIntl } from 'react-intl';
import { SlideTransition } from '../../Transition/Transition';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Grid } from '@mui/material';
import { DatePicker } from '../../ClickableField/ClickableField';
import moment from 'moment-timezone';
import { LOADING } from '../../../constants/phase';
import { enableTracking } from '../../../store/client/duck';
import { getClientConnectionStatus } from '../utils';
import BusinessVolControl from '../controls/BusinessVolControl/BusinessVolControl';
import { tracking } from '../../../utils/tracking';

const OPPORTUNITY_BACKGROUND_COLORS = { L: 'rgb(255, 106, 116)', M: 'rgb(255, 175, 25)', H: 'rgb(94, 224, 146)' };

class TrackOnDialog extends React.PureComponent {
  componentDidUpdate(prevProps, prevState) {
    const { toggleDialog } = this.props;
    if (this.props.enableTrackingPhase === true && prevProps.enableTrackingPhase === LOADING) {
      toggleDialog('trackOn', false);
    }
  }

  enableTracking = () => {
    const { trackOnDialog, userDetails, toggleDialog, enableTracking } = this.props;
    const { client, startDate, opportunity, expectedBusinessAmount } = trackOnDialog;

    let formattedStartDate = startDate
      ? moment.utc(moment(startDate).format('YYYY-MM-DD')).format('YYYY-MM-DDT00:00:00.00Z')
      : '';
    let obj = {};
    obj.clientId = client._id;
    obj.factsheetId = client.factsheetId._id;
    obj.advisorId = userDetails._id;
    obj.met = 0;

    if (!expectedBusinessAmount) {
      toggleDialog('trackOn', { ...trackOnDialog, errorExpectedBusinessAmount: 'Please fill in' });
      return;
    }

    // Added new filed on modal and also insert them on create new tracking
    obj.businessVol = expectedBusinessAmount;

    if (opportunity) {
      obj.opportunity = opportunity;
      if (opportunity === 'H') {
        let dateHigh = moment().format('YYYY-MM-DD');
        obj.dateHigh = moment.utc(dateHigh).format('YYYY-MM-DDT00:00:00.00Z');
        obj.dayCount = moment().diff(moment(formattedStartDate, 'YYYY-MM-DD'), 'days');
      } else {
        obj.dayCount = 0;
      }
    } else {
      obj.dayCount = 0;
    }

    obj.startDate = formattedStartDate;
    obj.isActive = client.trackingId ? !client.trackingId.isActive : true;
    obj.connectionStatus = getClientConnectionStatus(client);

    enableTracking(obj);

    // Tracking
    tracking('Enable Business Tracking');
  };

  close = () => this.props.toggleDialog('trackOn', { ...this.props.trackOnDialog, closed: true });
  closed = () => this.props.toggleDialog('trackOn', false);

  render() {
    const { intl, trackOnDialog, enableTrackingPhase, toggleDialog } = this.props;

    if (!trackOnDialog) return null;

    const { startDate, opportunity, expectedBusinessAmount, errorExpectedBusinessAmount, closed } = trackOnDialog;

    return (
      <Dialog
        open={!!trackOnDialog && !closed}
        onClose={this.close}
        fullWidth={true}
        slots={{
          transition: SlideTransition
        }}
        slotProps={{
          transition: {
            onExited: this.closed
          }
        }}>
        <DialogTitle>{intl.formatMessage({ id: 'BusinessTracking' })}</DialogTitle>
        <DialogContent>
          <DialogContentText>{intl.formatMessage({ id: 'bizTrackingDesc' })}</DialogContentText>
          <div className="modal-text">
            <Grid container spacing={2} sx={{ alignItems: 'center' }}>
              <Grid size={5} sx={{ textAlign: 'right', fontWeight: 'normal' }}>
                {intl.formatMessage({ id: 'Tracking start on' })}
              </Grid>
              <Grid size={7} sx={{ textAlign: 'left' }}>
                <DatePicker
                  className="case-datepicker close-case-date case-open-datepicker"
                  maxDate={moment()}
                  name="startDate"
                  format="DD-MMM-YYYY"
                  value={startDate}
                  onChange={date =>
                    toggleDialog('trackOn', {
                      ...trackOnDialog,
                      startDate: date,
                      startDateChanged: true
                    })
                  }
                />
              </Grid>

              <Grid size={5} sx={{ textAlign: 'right', fontWeight: 'normal' }}>
                {intl.formatMessage({ id: 'Opportunity' })}
              </Grid>
              <Grid size={7} sx={{ textAlign: 'left' }}>
                <div className="clientList" style={{ display: 'flex', gap: 8 }}>
                  {Object.keys(OPPORTUNITY_BACKGROUND_COLORS).map(key => (
                    <Button
                      key={key}
                      className="portfolio-default-button button-line-height"
                      style={{
                        background: opportunity === key ? OPPORTUNITY_BACKGROUND_COLORS[key] : '#ccc',
                        color: opportunity === key ? '#fff' : '#000',
                        margin: 0
                      }}
                      variant="contained"
                      onClick={() =>
                        toggleDialog('trackOn', {
                          ...trackOnDialog,
                          opportunity: key
                        })
                      }
                    >
                      {intl.formatMessage({
                        id: `opp${key}`
                      })}
                    </Button>
                  ))}
                </div>
              </Grid>

              <Grid size={5} sx={{ textAlign: 'right', fontWeight: 'normal' }}>
                {intl.formatMessage({ id: 'Expected Business' })}
              </Grid>
              <Grid size={7} sx={{ textAlign: 'left' }}>
                <BusinessVolControl
                  style={{
                    width: 120,
                    maxWidth: '100%',
                    borderBottom: '1px solid gray',
                    height: '25px',
                    color: '#3966f8'
                  }}
                  value={expectedBusinessAmount}
                  onChange={value =>
                    toggleDialog('trackOn', {
                      ...trackOnDialog,
                      expectedBusinessAmount: value,
                      errorExpectedBusinessAmount: undefined
                    })
                  }
                />
                <i className="bar bar-edit" />
                {errorExpectedBusinessAmount && (
                  <div className="error_field" style={{ fontSize: '13px', marginTop: '4px' }}>
                    {intl.formatMessage({ id: errorExpectedBusinessAmount })}
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.close} color="primary">
            {intl.formatMessage({ id: 'Cancel' })}
          </Button>
          <Button onClick={this.enableTracking} color="primary" disabled={enableTrackingPhase === LOADING} autoFocus>
            {intl.formatMessage({ id: 'OK' })}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const container = connect(
  // Map state to props
  state => ({
    userDetails: state.user.userDetails,
    trackOnDialog: state.control.trackOnDialog,
    enableTrackingPhase: state.client.enableTrackingPhase
  }),
  // Map actions to props
  {
    toggleDialog,
    enableTracking
  },
  // mergeProps
  null,
  // options
  {}
)(TrackOnDialog);

export default injectIntl(container);
